import { type ProjectCode } from '@constants'
import { type CosignContextProps } from '../components/useContextCosign'
import { cosignConfigMap } from '../constants/cosign-config'

export function getContactSupport(projectCode: ProjectCode | undefined) {
  const contactLink = projectCode
    ? (cosignConfigMap as Partial<Record<ProjectCode, CosignContextProps>>)[projectCode]?.serverLink
    : undefined

  const openContact = () => {
    if (!contactLink) return
    window.open(contactLink, '_blank', 'noopener,noreferrer')
  }

  return { contactLink, openContact }
}
